<template>
  <div v-if="options.length > 1">
    <b-form-select v-model="selected" :options="options"></b-form-select>
  </div>
  <div v-else class="uniqueChoise">{{ options[0]?.text ?? options[0] ?? '' }}</div>
</template>

<script>
export default {
  name: 'ComboOrLabel',
  props: {
    value: {required: true},
    options: {required: true}
  },
  computed: {
    selected: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      }
    }
  },
  watch: {
    options: {
      handler(newValue) {
        if (newValue.length === 1) {
          this.selected = newValue[0].value ?? newValue[0];
        }
      },
      immediate: true
    }
  },
  methods: {
    select(option) {
      this.$emit('click', option);
    }
  }
};
</script>

<style scoped>

.uniqueChoise {
  align-items: baseline;
}
</style>
